import { render, staticRenderFns } from "./detailPc.vue?vue&type=template&id=32a03a6c&scoped=true&"
import script from "./detailPc.vue?vue&type=script&lang=js&"
export * from "./detailPc.vue?vue&type=script&lang=js&"
import style0 from "./detailPc.vue?vue&type=style&index=0&lang=css&"
import style1 from "./detailPc.vue?vue&type=style&index=1&id=32a03a6c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a03a6c",
  null
  
)

export default component.exports